// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CaGE","tabsBox":"styles_tabsBox__3uHCw","createButton":"styles_createButton__MWuhd"};